module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wordboard"
  }, [(_vm.wordboards.length > 0) ? _c('div', [_c('el-select', {
    attrs: {
      "placeholder": _vm.$t('wordboard.chooseWord')
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  }, _vm._l((_vm.wordboards), function(item) {
    return _c('el-option', {
      key: item.title,
      attrs: {
        "label": item.title,
        "value": item.text
      }
    })
  })), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.addWord()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('wordboard.add')))])], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-69418792"}!./src/components/wordboard/wordboard.html
// module id = 814
// module chunks = 1